import styled from "styled-components"

export const Wrapper = styled.div`

/* background-color:#f6f6f64a; */
background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(246,246,246,1) 35%, rgba(255,255,255,1) 62%);
`


